module.exports = __webpack_public_path__ + "static/media/logoH.1aa63cb4.png";